import React from 'react';
import useArticles from '../hooks/useArticles';
import HomeAboutSection from './home/components/HomeAboutSection';
import HomeBlogSection from './home/components/HomeBlogSection';
import HomeContactSection from './home/components/HomeContactSection';
import HomeFeaturedProjectsSection from './home/components/HomeFeaturedProjectsSection';
import HomeHeroSection from './home/components/HomeHeroSection';
import { useFeaturedProjects } from './home/hooks/useFeaturedProjects';

const Home = () => {
  const { featuredProjects, featuredStatus, featuredError } = useFeaturedProjects();
  const { articles: latestPosts, status: articlesStatus } = useArticles(3);

  return (
    <>
      <HomeHeroSection />

      <main>
        <HomeAboutSection />
        <HomeFeaturedProjectsSection
          featuredStatus={featuredStatus}
          featuredError={featuredError}
          featuredProjects={featuredProjects}
        />
        <HomeBlogSection articlesStatus={articlesStatus} latestPosts={latestPosts} />
        <HomeContactSection />
      </main>
    </>
  );
};

export default Home;
